import React from 'react';
import tw from 'tailwind-styled-components';
import ProductItem from './ProductItem'; 
import { useSelector, useDispatch } from 'react-redux';
import { Set_Cart_Modal_Open } from '../Redux/actions';
import { useNavigate } from 'react-router-dom';

const RecommendedProducts = ({ products, title = "You Might Also Like", onOpenLoginModal }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Function to handle opening the cart modal
    const handleOpenCartModal = () => {
        dispatch(Set_Cart_Modal_Open(true));
    };

    // Close current modal/page before navigating to the new product page
    const handleProductClick = (product) => {
        // If this component is shown inside the Cart modal, close it first
        dispatch(Set_Cart_Modal_Open(false));
        // Navigate to the clicked product's page
        navigate(`/product/${product.id}`, { state: { productData: product } });
    };


    if (!products || products.length === 0) {
        return null; // Don't render anything if no recommended products
    }

    return (
        <RecommendedSection>
            <SectionTitle>{title}</SectionTitle>
            {/* Horizontal Scroll for Mobile, Grid for Desktop */}
            <ProductsContainer>
                {products.map((product) => (
                    <ProductItemWrapper key={product.id}>
                        <ProductItem
                            product={product}
                            onOpenLoginModal={onOpenLoginModal}
                            onOpenCartModal={handleOpenCartModal}
                            // Override the default click behavior to close modal first if needed
                            onProductClick={() => handleProductClick(product)} 
                        />
                    </ProductItemWrapper>
                ))}
            </ProductsContainer>
        </RecommendedSection>
    );
};

// Styled Components
const RecommendedSection = tw.div`py-6`;
const SectionTitle = tw.h3`text-lg font-semibold text-gray-800 mb-3 px-4`;
const ProductsContainer = tw.div`flex overflow-x-auto space-x-3 px-4 pb-2 scrollbar-hide md:grid md:grid-cols-6 md:gap-4 md:space-x-0 md:overflow-visible`;
const ProductItemWrapper = tw.div`flex-shrink-0 w-40 md:w-auto`;

export default RecommendedProducts;